import { jsx } from "react/jsx-runtime";
import { ArrowDropDown } from "@mui/icons-material";
import { ButtonBase, IconButton, TextField, inputBaseClasses, styled } from "@mui/material";
import { NO_COLOR } from "../../constants.js";
import { useColorPicker } from "../../hooks/useColorPicker.js";
import { Chip } from "../Swatch/components/Chip.js";
import { NoColorChip } from "../Swatch/components/NoColorChip.js";
import { NoColorIcon } from "../Swatch/components/NoColorIcon.js";
const chipSize = 24;
function SelectTrigger(props) {
  const { onClick, color, open, colorLabel, disabled, sx } = props;
  const { localeText } = useColorPicker();
  const colorText = color === NO_COLOR ? localeText.noColorLabel : color;
  const textFieldValue = typeof colorLabel === "function" ? colorLabel(color) : colorLabel ?? colorText;
  return /* @__PURE__ */ jsx(BaseButton, { onClick, disableRipple: true, disabled, sx, children: /* @__PURE__ */ jsx(
    TextField,
    {
      "data-testid": "SelectTrigger--TextField",
      sx: {
        [`& .${inputBaseClasses.input}`]: {
          cursor: "pointer"
        }
      },
      label: localeText.triggerSelectLabel,
      value: textFieldValue,
      InputProps: {
        readOnly: true,
        endAdornment: /* @__PURE__ */ jsx(EndAdornment, { open, onClick }),
        startAdornment: /* @__PURE__ */ jsx(StartAdornment, { color })
      },
      focused: open,
      disabled,
      fullWidth: true
    }
  ) });
}
function EndAdornment(props) {
  const { open, onClick } = props;
  return /* @__PURE__ */ jsx(IconButton, { component: "span", onClick, children: /* @__PURE__ */ jsx(
    ArrowDropDown,
    {
      color: "action",
      style: { transition: "rotate 0.2s ease", rotate: `${open ? "-180deg" : "0deg"}` }
    }
  ) });
}
function StartAdornment(props) {
  const { color } = props;
  if (color === NO_COLOR) {
    return /* @__PURE__ */ jsx(
      NoColorChip,
      {
        "data-testid": "TidalColorPickerPopoverSwatch",
        component: "span",
        size: chipSize,
        bgcolor: color,
        sx: { mr: 1 },
        children: /* @__PURE__ */ jsx(NoColorIcon, {})
      }
    );
  }
  return /* @__PURE__ */ jsx(Chip, { "data-testid": "TidalColorPickerPopoverSwatch", component: "span", size: chipSize, bgcolor: color, sx: { mr: 1 } });
}
const BaseButton = styled(ButtonBase, {
  slot: "SelectTriggerButtonBase"
})(() => {
  return {
    width: "100%"
  };
});
export {
  BaseButton,
  SelectTrigger
};
//# sourceMappingURL=SelectTrigger.js.map
